<template>
  <div class="desk-frame contact-page cellosign-page">
    <div
      class="head_row_calander bg--white flex flex--content--center no_mobile"
    >
      <h1 class="title title--40 no-marge tx--blue2">
        {{ config ? config.title : "" }}
      </h1>
    </div>
    <menu-desktop class="no_mobile" />

    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <transition name="slide">
      <div class="contact h-main bg--white m-no-bg page-edit-padd">
        <div class="iframe-container">
          <button class="back-button" @click="onBack" type="button">
            <span class="arrow">‹</span>
            <span>{{ config ? config.backText : "" }}</span>
          </button>

          <div v-if="errorMessage" class="error-container">
            <p class="error-message">{{ errorMessage }}</p>
            <button class="bt_blue" @click="retry" type="button">
              נסה שנית
            </button>
          </div>

          <div v-else-if="!iframeUrl" class="loader-container">
            <vue-loaders-ball-clip-rotate
              color="#30448d"
              scale="2"
            ></vue-loaders-ball-clip-rotate>
          </div>

          <iframe
            v-else
            :src="iframeUrl"
            width="100%"
            height="700vh"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import { sendCelloSign, sendCelloSignGeneric } from "../api/api-quatro.js";
import { iframeConfigs } from "../utilities/iframe-cellosign-config.js";
import { EXCEPTION_COMMITTEE_ENABLED } from "../utilities/feature-flags.js";

export default {
  name: "CellosignIframe",
  components: {
    DashboardHeader,
    Menu,
    MenuDesktop
  },
  data() {
    return {
      iframeUrl: "",
      formaData: null,
      errorMessage: "",
      config: null
    };
  },
  computed: {
    ...mapState(["activeDoctor"]),
    ...mapGetters(["MENU_ACTIVE"])
  },
  methods: {
    onBack() {
      const route = this.config.backRoute();
      if (!route) {
        this.$router.go(-1);
        return;
      }
      this.$router.push(route);
    },
    async loadData() {
      try {
        this.formaData = await this.config.loadData(this);
      } catch (error) {
        this.errorMessage = error.message || "אירעה שגיאה בטעינת נתוני האירוע";
        console.error("Error loading data for iframe", error);
      }
    },
    async getIframeUrl() {
      this.errorMessage = "";
      this.iframeUrl = "";

      const basePayload = this.config.buildBasePayload(this);

      try {
        let url;
        if (this.config.generic) {
          const data = {
            ...basePayload,
            ...(this.formaData || {}),
            wait_for_first_session: true
          };
          const req = {
            url: this.config.generic.url,
            data
          };
          if (this.config.generic.project) {
            req.project = this.config.generic.project;
          }
          if (this.config.template) {
            req.template = this.config.template;
          }
          const response = await sendCelloSignGeneric(req);
          url = response?.data?.data?.session?.client_url;
        } else {
          let req = { ...basePayload };
          if (this.config.template) {
            req.template = this.config.template;
          }
          if (this.formaData) {
            req = { ...req, ...this.formaData };
          }
          const response = await sendCelloSign(req, this.config.endpoint);
          url = response?.data?.session?.client_url;
        }

        if (!url) {
          this.errorMessage = "לא התקבל קישור מהשרת, נסה שנית מאוחר יותר";
          return;
        }
        this.iframeUrl = url;
      } catch (error) {
        this.errorMessage = "אירעה שגיאה בטעינת הטופס, נסה שנית מאוחר יותר";
        console.error("Error sending cellosign", error);
      }
    },
    async retry() {
      this.errorMessage = "";
      await this.loadData();
      if (!this.errorMessage) {
        await this.getIframeUrl();
      }
    }
  },
  async created() {
    const type = this.$route.params.type;

    if (type === "exception-committee" && !EXCEPTION_COMMITTEE_ENABLED) {
      this.$router.replace("/dashboard");
      return;
    }

    this.config = iframeConfigs[type];

    if (!this.config) {
      this.errorMessage = "סוג טופס לא תקין";
      return;
    }

    await this.loadData();
    if (!this.errorMessage) {
      await this.getIframeUrl();
    }
  }
};
</script>

<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}
.error-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  gap: 20px;
}
.error-message {
  color: #e74c3c;
  font-size: 18px;
  font-weight: 600;
}
</style>
